const REPORT_STATE = {
    PENDING: 'pending',
    EVALUATION_STARTED: 'evaluation_started',
    EVALUATED: 'evaluated',
    READY: 'ready',
    PUBLISHED: 'published',
}

export default REPORT_STATE
